import { Component, Input } from '@angular/core';
import { CartItem } from '@shared/models/cart-item.model';
import { ProductSku } from '@shared/models/product-sku.model';
import { ShoppingCart } from '@shared/models/shopping-cart.model';
import { CartService } from '@shared/services/cart.service';
import Swal from 'sweetalert2';

@Component({
  selector: 'app-checkout-items',
  templateUrl: './checkout-items.component.html',
  styleUrls: ['./checkout-items.component.scss']
})
export class CheckoutItemsComponent {
  @Input() cart: ShoppingCart;

  constructor(private cartService: CartService) {}

  onAdd(item: CartItem): void {
    item.quantity += 1;
    this.cartService.updateCart(item).subscribe((data: ShoppingCart) => {
      this.cartService.setCart(data);
    });
  }

  onSubtract(item: CartItem): void {
    if (item.quantity <= 1) return;
    item.quantity -= 1;
    this.cartService.updateCart(item).subscribe((data: ShoppingCart) => {
      this.cartService.setCart(data);
    });
  }

  onRemove(item: CartItem): void {
    Swal.fire({
      title: '確定移除這個商品嗎？',
      icon: 'question',
      showCancelButton: true,
      confirmButtonText: '移除',
      cancelButtonText: '取消',
      confirmButtonColor: '#FF3C00',
      reverseButtons: true
    }).then(result => {
      if (result.isConfirmed) {
        this.cartService.deleteCartItem(item).subscribe((data: ShoppingCart) => {
          this.cartService.setCart(data);
        });
      }
    });
  }

  splitName(fullName: string): { zh: string; en: string } {
    if (!fullName) return { zh: '', en: '' };
    const match = fullName.match(/^(.+?)\s+([A-Za-z].*)$/);
    if (match) return { zh: match[1].trim(), en: match[2].trim() };
    return { zh: fullName.trim(), en: '' };
  }

  nameOf(item: CartItem): { zh: string; en: string } {
    const eavs = (item && item.productSku && item.productSku.productSkuEavs) || [];
    const nameEav = eavs.find((e: any) => e.attribute === 'name');
    return this.splitName(nameEav ? nameEav.value : '');
  }

  imageOf(item: CartItem): string {
    const imgs = (item && item.productSku && item.productSku.images) || [];
    const thumb = imgs.find((i: any) => i.type === 'THUMBNAIL') || imgs[0];
    return thumb ? (thumb.domain + thumb.path) : '';
  }

  isSalesPrice(sku: ProductSku): boolean {
    if (sku && sku.salesFrom && sku.salesTo && sku.salesPrice) {
      const now = Date.now() / 1000;
      return now > sku.salesFrom && now < sku.salesTo;
    }
    return false;
  }
}
